import { featureCollection } from "@turf/helpers";
import { useContext, useEffect } from "react";
import { MapitStateContext } from "src/states/MapitState";
import { actionGoToModus, RightPaneContext, RightPaneModus } from "src/states/RightPaneState";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";


export function AddAsDrawing(props: { managedWindow: ManagedWindow; layers: any[] }) {

   const { dispatch: rightPaneDispatch } = useContext(RightPaneContext);
   const { dispatch: windowDispath } = useWindowContext();
   const { state: mapitState } = useContext(MapitStateContext);

   useEffect(() => {
      if (mapitState.drawContent) {
         let preparedLayers = featureCollection(props.layers.flatMap(layer => layer.features));
         mapitState.drawContent.set?.(preparedLayers);
         rightPaneDispatch(actionGoToModus(RightPaneModus.Map_Measure))
         windowDispath(closeWindow(props.managedWindow.id));
      } else {
         rightPaneDispatch(actionGoToModus(RightPaneModus.Map_Measure))
      }
   }, [mapitState.drawContent])

   return <div style={{ backgroundColor: "yellow" }}><h1>Add As Drawing</h1></div>;
}